// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"66":"d15774a4","700":"45b4a3ce","726":"61453923","792":"47b02eb8"}[chunkId] + ".css";
};